module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harry Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Harry Harrison (1925–2012) began writing science fiction in the 1950s and remains one of the top-selling authors in the genre. Harrison is best known for his Stainless Steel Rat, Deathworld, and West of End series, as well as "), _c('I', [_vm._v("Make Room! Make Room!")]), _vm._v(", which was turned into the movie "), _c('I', [_vm._v("Soylent Green ")]), _vm._v("starring Charlton Heston and Edward G. Robinson. His novels have appeared on the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestseller list, and in 2009 he was awarded the Damon Knight SF Grand Master Award by the Science Fiction Writers of America.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AznBWC/tc-custom/9781466822740.jpg?1721057612324",
      "alt": "This image is the cover for the book Homeworld, To the Stars Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Homeworld, To the Stars Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The first volume in Harry Harrison's epic To the Stars Trilogy, "), _c('i', [_vm._v("Homeworld ")]), _vm._v("is a stark and compelling vision of the future. ")]), _c('br'), _c('br'), _c('i', [_vm._v("Homeworld is heaven on Earth.")]), _c('br'), _c('i', [_vm._v("If you don't ask questions...")]), _c('br'), _c('br'), _vm._v("Homeworld is stable at last, hundreds of years after the collapse of the 20th Century economy. For the millions of proles, life is still a grim ordeal, but for the lucky few, like Engineer Jan Kulozik, there is every kind of luxury. Except one. On Homeworld, where everything and everyone is monitored by the faceless power of government, there is no freedom. "), _c('br'), _c('br'), _vm._v("Jak Kulozik knew nothing of the Resistance; he probably didn't want to. But suddenly, he is part of it. And running for his life..."), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0